import React, { useEffect, useMemo, useRef } from 'react';
import { MonitorSmartphoneIcon, XIcon } from 'lucide-react';
interface MobilePreviewProps {
  onClose: () => void;
}
export function MobilePreview({
  onClose
}: MobilePreviewProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const previewUrl = useMemo(() => {
    const url = new URL(window.location.href);
    url.searchParams.set('mobile-preview', '1');
    url.hash = '';
    return url.toString();
  }, []);
  useEffect(() => {
    closeButtonRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);
  return <div className="fixed inset-0 z-[70] flex items-center justify-center bg-ink/85 p-4 sm:p-8" role="dialog" aria-modal="true" aria-labelledby="mobile-preview-title" data-id="element-105" data-mp="1mp39cmont425">
      <div className="relative flex h-[min(92vh,820px)] w-full max-w-[430px] flex-col overflow-hidden rounded-[2.5rem] border-[7px] border-ink bg-ink shadow-[0_0_0_2px_#ffffff,12px_12px_0_#D9FF3F]" data-id="element-106" data-mp="3okltwep0sw74">
        <div className="flex shrink-0 items-center justify-between bg-ink px-5 py-3 text-white" data-id="element-107" data-mp="jjn1gufbk0gw">
          <div className="flex items-center gap-2" data-id="element-108" data-mp="oiq282o9nkj2">
            <MonitorSmartphoneIcon className="h-4 w-4 text-lime" data-id="element-109" data-mp="tckrdlmn4rpj" />
            <p id="mobile-preview-title" className="text-xs font-extrabold uppercase tracking-[0.12em]" data-id="element-110" data-mp="yaw1zykrf68t">
              Vista móvil
            </p>
          </div>
          <button ref={closeButtonRef} type="button" onClick={onClose} className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-ink transition-colors hover:bg-lime focus:outline-none focus-visible:ring-4 focus-visible:ring-lime" aria-label="Cerrar vista móvil" data-id="element-111" data-mp="137vx5eg2mol5">
            <XIcon className="h-4 w-4" data-id="element-112" data-mp="3e0ypyzcppda8" />
          </button>
        </div>
        <iframe title="Vista móvil de la página de Byronweb" src={previewUrl} className="min-h-0 w-full flex-1 bg-warm" data-id="element-113" data-mp="l79yjexdja7i" />
      </div>
    </div>;
}